// ms
export const POLLING_INTERVAL = 2000;
// ms
export const LONG_POLLING_INTERVAL = 15000;
// ms
export const VERY_LONG_POLLING_INTERVAL = 60000;
